import { HttpClient } from 'aurelia-http-client';
export class YoutubeAPI {
  constructor(apiLoadedCallback, apiReady, apiBase) {
    this.OAUTH2_SCOPES = 'https://www.googleapis.com/auth/youtube.upload';
    this.apiLoadedCallback = apiLoadedCallback;
    this.apiReady = apiReady;
    this.apiBase = apiBase;
    this.client;

    }
  // Upon loading, the Google APIs JS client automatically invokes this callback.
  googleApiClientReady() {
    // gapi.auth.ini
      this.apiLoadedCallback();


  }

  initClient(){
    this.client = google.accounts.oauth2.initTokenClient(
      {
        client_id: this.OAUTH2_CLIENT_ID,
        scope: this.OAUTH2_SCOPES,
        callback:(tokenResponse) => {
          console.log('aaa',tokenResponse)
          this.access_token = tokenResponse.access_token;
          this.authSuccessfulCallback();
        }
      });

  }

  getClientId(token, successCallback, errorCallback) {
    var http = new HttpClient().configure(x => {
      x.withHeader('Content-Type', 'application/json')
        .withHeader("Authorization", token);
    });


    http.get(this.apiBase + '/youtube/getClientID')
      .then(data => {

        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("client_id")) {
            this.OAUTH2_CLIENT_ID = json.client_id;

              // this.client.requestCode();
            successCallback();
            this.initClient();

          } else {
            errorCallback("No Client ID");
          }

          if (json.hasOwnProperty("error"))
            errorCallback(json.error);

        }
        else {
          errorCallback(data.statusText);
        }
      });

  }

  // Attempt the immediate OAuth 2.0 client flow as soon as the page loads.
  // If the currently logged-in Google Account has previously authorized
  // the client specified as the OAUTH2_CLIENT_ID, then the authorization
  // succeeds with no user intervention. Otherwise, it fails and the
  // user interface that prompts for authorization needs to display.
  checkAuth() {
    this.authSuccessfulCallback = null;
    console.log(this.client)

  }

  // Handle the result of a gapi.auth.authorize() call.
  handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      // Authorization was successful.
      this.access_token = authResult.access_token;
      if(this.authSuccessfulCallback)
        this.authSuccessfulCallback();
    } else {
      this.access_token = null;

    }

    this.apiReady();

  }

  loginToYoutube(authSuccessfulCallback) {
    this.authSuccessfulCallback = authSuccessfulCallback;
    this.requestToken();

  }

   requestToken() {
    this.client.requestAccessToken();
  }

  uploadToYoutube(id, capture_type, title,tags, description,videoVisibitily,uploadDefault, token, successCallback, errorCallback) {
    var http = new HttpClient().configure(x => {
      x.withHeader('Content-Type', 'application/json')
        .withHeader("Authorization", token);
    });

    var data = {
      "id": id,
      "capture_type": capture_type,
      "title": title,
      "tags":tags,
      "description": description,
      "visibility":videoVisibitily,
      "uploadDefault":uploadDefault,
      "access_token": this.access_token };

    http.post(this.apiBase + '/youtube/upload', data)
      .then(data => {

        if (data.isSuccess) {
          if (data.response) {
            var json = JSON.parse(data.response);

            if (json.hasOwnProperty("error")) {
              errorCallback(json.error);
              return;
            }
          }
          successCallback();

        }
        else {
          errorCallback(data.statusText);
        }
      }).catch(() => {errorCallback("Error uploading to Youtube");});

  }
  uploadVideoChatbot(account_id, preprocessedLink,id, method  , token, successCallback, errorCallback) {
    var http = new HttpClient().configure(x => {
        x.withHeader('Content-Type', 'application/json')
         .withHeader("Authorization", token);
    });
    var data = {
        "id": account_id,
        "video_link": preprocessedLink,
        "video_id":id,
        "method": method  // You can change to "delete" if needed
    };
    console.log("Sending Data:", data);
    http.post(this.apiBase + '/account/chatbot/videoSave', {'chatbot':data})
        .then(data => {

          if (data.response) {
            var json = JSON.parse(data.response);

            console.log("Response Data:", json);

            if (json.hasOwnProperty("error")) {
                errorCallback(json.error);
                return;
            }

            successCallback();
          } 
        })
        .catch(error => {
            console.error("Upload Error:", error);
            errorCallback("Error uploading the video. Please try again later.");
        });
}












  // Load the client interfaces for the YouTube Analytics and Data APIs, which
  // are required to use the Google APIs JS client. More info is available at
  // https://developers.google.com/api-client-library/javascript/dev/dev_jscript#loading-the-client-library-and-the-api
  loadAPIClientInterfaces() {
    // gapi.client.load
    alert("dffff")
    // this.client= google.accounts.oauth2.initCodeClient('youtube', 'v3', function () {
    //   this.handleApiLoadedCallback();
    // }.bind(this));
    alert("loadAPIClientInterfaces");

  }


}
